import React, { useState } from 'react';
import {
  CheckBoxSelection,
  Inject,
  MultiSelectComponent,
} from '@syncfusion/ej2-react-dropdowns';
import './OpMultiCheckBoxSelect.css';

export const OpMultiCheckBoxSelect = (props) => {
  const {
    cssClass, // Custom class to style the element
    dataSource, // List of objects that contains id and name
    fields, // An object to specify which property to display and which property is the value
    label, // Display text outside the button
    labelPosition, // Position of label text from the button: 'left' else will always place on top
    onChange, // The select function of multi select
    placeholder, // Text display when there is no selected item
    showDropDownIcon = true, // Shows the triangle dropdown icon
  } = props;
  const rootElementStyle =
    labelPosition === 'left' ? { display: 'flex' } : null;
  const labelStyle =
    labelPosition === 'left' ? { marginRight: '10px', marginTop: '9px' } : null;
  const [selectedItems, setSelectedItems] = useState('');

  const handleOnClick = (params) => {
    if (typeof onChange === 'function') onChange(params);

    // To show tooltips when an item is selected
    const selectedNodes = params.target.mainData
      .filter((data) => params.value.includes(data.id))
      .map((data) => data.name);

    if (selectedNodes && selectedNodes.length) {
      setSelectedItems(selectedNodes.join(', '));
    } else {
      setSelectedItems('');
    }
  };

  return (
    <div
      className={'op-multi-select-external-wrapper'}
      style={rootElementStyle}
      title={selectedItems}
    >
      {label && (
        <label className={'op-multi-select-external-label'} style={labelStyle}>
          {label}
        </label>
      )}
      <MultiSelectComponent
        cssClass={`op-multi-select ${cssClass}`}
        dataSource={dataSource}
        fields={fields}
        mode={'CheckBox'}
        onChange={handleOnClick}
        placeholder={placeholder}
        showDropDownIcon={showDropDownIcon}
      >
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
};
